import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCompany, acceptCompanyRVMUsage } from "../actions/index";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";
import * as Constants from '../constants';

class TermsVoicemailPage extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    acceptCompanyRVMUsage: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showAgreeBtn: false
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.data.data.latest_rvm_usage_accepted != true) {
        this.setState({ showAgreeBtn: true });
      }
    });
  }

  agree() {
    this.props
      .acceptCompanyRVMUsage().then(response => {
        if (response.payload.status == "200") {
          this.props.history.push(`/${response.payload.config.headers["X-Site-UUID"]}/rvm_templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  render() {
    return (
      <div>
        <h1>Voicemail Usage Terms</h1>
        <p>
          Ringless voicemails are currently capped at 1,000 successful voicemails per month.
          After reaching this cap, any voicemail steps will be skipped.
        </p>
        <p>
          After beta, sending voicemail will incur a cost.
        </p>
        <p>
          The cost has not yet been decided.
        </p>
        <p>
          By clicking &quot;I agree&quot; below, you are agreeing to additional costs after this service leaves beta.
        </p>
        <Button
          className={`btn btn-primary i_agree_btn ${
            this.state.showAgreeBtn ? "show" : "hide"
          }`}
          onClick={this.agree.bind(this)}
        >
          I Agree
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany, acceptCompanyRVMUsage }
)(TermsVoicemailPage);
